/**
 * ¿A qué pantalla pertenece cada rol cuando hay que llevarlo «a su sitio»?
 *
 * ⚠️⚠️ Esta correspondencia estaba copiada en CUATRO sitios —`LandingPage`,
 * `LoginPage`, `RegisterPage` y `MagicLinkLoginPage`— y la pantalla de acceso
 * denegado iba a ser la quinta. Su único botón hacía `window.history.back()`, y
 * MEDIDO POR LA UI el 2026-08-14 eso no lleva a ninguna parte:
 *
 *     antes de pulsar   /unauthorized
 *     después           /unauthorized      ← el mismo sitio
 *
 * La entrada anterior del historial es justamente la ruta que el guarda acaba
 * de rechazar, así que volver atrás vuelve a expulsar. Sin barra de navegación
 * y sin un solo enlace en esa página, el usuario queda encerrado: la única
 * salida era escribir una URL a mano.
 *
 * Al derivar el destino del ROL no puede volver a pasar: siempre existe una
 * pantalla que ese usuario sí puede abrir.
 */

/** Los roles con casa propia; cualquier otro va al libro de transacciones. */
const HOME_ROUTE_BY_ROLE: Record<string, string> = {
  super_admin: '/admin/system/dashboard',
  org_admin: '/admin/org/dashboard',
}

/** La casa de un usuario corriente, y el respaldo de todo lo demás. */
export const DEFAULT_HOME_ROUTE = '/transactions'

/**
 * @param role - `user.role`, o `undefined` mientras la sesión no se conoce.
 * @param intendedPath - la ruta que el usuario pedía antes de que le mandaran a
 *   iniciar sesión (`location.state.from.pathname`). Sólo se respeta para los
 *   roles SIN panel propio: a un administrador se le lleva a su tablero, que es
 *   lo que hacían las cuatro copias. Puede llegar como cadena vacía desde el
 *   estado sin tipar del router, y entonces NO cuenta como destino.
 */
export function resolveHomeRouteForRole(
  role: string | undefined | null,
  intendedPath?: string | null,
): string {
  // `hasOwn`: a custom role named `constructor` or `toString` must not resolve to an inherited function.
  if (role != null && Object.hasOwn(HOME_ROUTE_BY_ROLE, role)) return HOME_ROUTE_BY_ROLE[role]
  return intendedPath != null && intendedPath !== '' ? intendedPath : DEFAULT_HOME_ROUTE
}
